export const FolderIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 7.5C3 6.39543 3.89543 5.5 5 5.5H9.17157C9.70201 5.5 10.2107 5.71071 10.5858 6.08579L11.9142 7.41421C12.2893 7.78929 12.798 8 13.3284 8H19C20.1046 8 21 8.89543 21 10V17.5C21 18.6046 20.1046 19.5 19 19.5H5C3.89543 19.5 3 18.6046 3 17.5V7.5Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
